import React, { useState, useEffect } from "react"
import { ApiGetBankList, ApiCheckUserMenuAccess } from "utils/constants/api";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, PageSize, PageTypeGetPaged, PaginationBack, PaginationFirst, PaginationLast, PaginationNext } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import useFetch from "utils/hooks/useFetch";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import SearchButton from "components/Button/SearchButton";
import PaginationButton from "components/Input/PaginationButton";
import { RoundTwoDecimals } from "utils/helpers";


export default function Bank(){
    const { data: productionBankList, fetch: getProductionBankList } = useFetch(ApiGetBankList)

    const { fetch: checkAccess } = useFetch(ApiCheckUserMenuAccess)

    const [companyName, setCompanyName] = useState(EmptyString)
    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    useEffect(() => {
        setLoading({isOpen: false})
        searchBtnClick()
    },[])

    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    
    async function searchBtnClick (){
        setLoading({isOpen: true})

        fSearchBtnClick(0).then((res) => {
            if (res !== null){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, pageIndex)
            }
            setLoading({isOpen: false})
        })
    }
    
    async function fSearchBtnClick (index){
        let res 
        
        await getProductionBankList({
            data: {
                companyName: companyName,
                pageSize: PageSize,
                pageIndex: parseInt(index),
                pageType: PageTypeGetPaged,
                sortBy: "A.CompanyName",
                sortOrder: "ASC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
        
        return res
    }

    async function fCheckUserAccess(userId, menuId, companyId){     
        let access
        
        await checkAccess({
            data: {
                userId: userId, 
                menuId: menuId,
                companyId: companyId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                access = response.data
            }else if(response.status === ApiResponseStatusUnauthorized){
                window.location.href = "/login"
            }
        })
        
        return access
    }


    
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fSearchBtnClick(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fSearchBtnClick(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fSearchBtnClick(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fSearchBtnClick(index)
        }
    }

    function fPaginationIndexChange(index){
        setPageIndex(index)
        fSearchBtnClick(index)
    }

    return(
        <div className="flex flex-col gap-2">
             <div>
                <span className="font-semibold text-2xl">Bank Summary</span>
            </div>
            <hr />

            <div className="mt-5 flex justify-between">
                <div className="flex gap-5">
                    <div className="flex flex-col gap-2">
                        <span>Company Name</span>
                        <input className="input" value={companyName} onChange={(e) => { setCompanyName(e.target.value) }} />
                    </div>
                </div>
                <div className="flex items-end">
                    <SearchButton onClick={() => { searchBtnClick() }} />
                </div>
            </div>

            <div className="mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Company Name</th>
                            <th className="font-semibold text-center px-2">Bank In</th>
                            <th className="font-semibold text-center px-2">Bank Out</th>
                            <th className="font-semibold text-center px-2">Balance</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        { productionBankList?.data?.listData.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y" key={i}>
                                    <td className="text-center">{i + 1}</td>
                                    <td className="px-2">
                                        <span>{ data?.companyName }</span>
                                    </td>
                                    <td className={`px-2 text-right`}
                                    >
                                        <span className={`px-2 text-right`}>
                                            Rp { new Intl.NumberFormat().format(RoundTwoDecimals(data?.bankIn || 0)) }
                                        </span>
                                    </td>
                                    <td className={`px-2 text-right`}
                                    >
                                        <span className={`px-2 text-right`}>
                                            Rp { new Intl.NumberFormat().format(RoundTwoDecimals(data?.bankOut || 0)) }
                                        </span>
                                    </td>
                                    <td className={`px-2 text-right`}
                                    >
                                        <span className={`px-2 text-right`}>
                                            Rp { new Intl.NumberFormat().format(RoundTwoDecimals(data?.balance || 0)) }
                                        </span>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
            {/* {loading ? (<LoadingModal />) : (<div />)} */}
            {loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}